/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import { AgGridReact } from 'ag-grid-react';
import { AllModules } from 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'ag-grid-enterprise';
import ReadAxios from '../../axiosComponent/read'
import UserActionButton from './userActionButton';
import AgGridTable from '../../agGridComponent/agGridTable';
import { userHeaders } from '../../../utils/constants/user.constants';
import { tableHeaders,tableMessage } from '../../../utils/constants/table.constants';
import { FEATURES } from '../../../utils/constants';

function UserTable(props) {
  const [users, setusers] = useState([])
  const [isLoaded, setisLoaded] = useState(false)
  const [isUpdated, setisUpdated] = useState(false)
  useEffect(() => {
    getData()
  }, [isUpdated])
  let getUpdate = (data) => {
    if (data) {
      setisUpdated(!isUpdated)
    }
  }

  let getData = () => {
    ReadAxios({ url: 'masters/userMaster', readItems: { 'status': 1 }, typeOfResult: 'resultSet' }).then((result) => {
      // console.log("&*********************************#############")
      // console.log(result);

      setusers(result)
      setisLoaded(true)
    })
  }

  if (users?.length === 0 && isLoaded === false) {
    return (
      <LoadingPlaceholder />
    )
  } else if (users?.length === 0) {
    return (
      <Segment className="m-2">
        <center> <Header>{tableMessage.NO_RECORD}</Header></center>
      </Segment>
    )
  } else {

    let columnDefs = [
      /* { headerName: 'Employee Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true }, */
      { headerName: userHeaders.USER_NAME, field: 'username', tooltipField: 'username', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: userHeaders.EMPLOYEE_NAME, field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: userHeaders.ROLE, field: 'role', tooltipField: 'role', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: userHeaders.MOBILE_NUMBER, field: 'mob', tooltipField: 'mob', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: userHeaders.MOBILE_NUMBER, field: 'email', tooltipField: 'email', enableRowGroup: true, enablePivot: true },
      { headerName: tableHeaders.EDIT_DELETE, field: 'edit', cellRenderer: 'actionRenderer' },
    ]
    let rowData = [];
    (users != null || users != undefined) && users.map((object, i) => {
      let temp = {}
      if(object.role != 'elixir' || object.role != 'ELIXIR'){
      temp.code = object.userCode ? object.userCode.toUpperCase() : ''
      temp.username = object.username
      temp.name = `${object.realname}`
      temp.role = object.role
      temp.email = object.email_address
      temp.mob = object.mobile_number
      temp.id = object.userId
      temp.customerNo = object.customerNo
      temp.fullData = object
      rowData[i] = temp
      }
    })
    return (
      <React.Fragment >
        <AgGridTable
          columnDefs={columnDefs}
          rowData={rowData}
          searchValue={props.searchValue}
          actionButton={UserActionButton}
          reload={getUpdate}
          link="#"
          hiddenNew={true}
          newPopup={props.newPopup}
          titleBarTitle="Users"
          handleSearch={props.handleSearch}
          hiddenImportPopupBtn={true}
          showImport={true}
          fileName="userMaster"
          importSubUrl={'masters/import/userMaster'}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    )
  }

}

export default UserTable
